<template>
  <div class="v-h-center">
    <div>
      <div class="circle"></div>
      <div class="circle-small"></div>
      <div class="circle-big"></div>
      <div class="circle-inner-inner"></div>
      <div class="circle-inner"></div>
      <div class="text-wrapper">
        <div class="title">
          <b>{{ title || this.$t('text.loading_chart').toUpperCase() }}</b>
        </div>
        <div class="content">{{ $t('text.please_wait') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      require: false
    }
  }
}
</script>

<style lang="css" scoped>
* {
  margin: 0;
  padding: 0;
}
.text-wrapper {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  width: 300px;
  margin-top: 45px;
}
.text-wrapper .title {
  font-size: 16px;
}
.circle {
  width: 108px;
  height: 108px;
  border: 6px inset rgb(133, 224, 242);
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -54px;
  margin-top: -84px;
  border-radius: 54px;
  -moz-animation: rotate 5s infinitelinear;
  -webkit-animation: rotate 5s infinite linear;
  animation: rotate 5s infinite linear;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.circle-small {
  width: 86px;
  height: 86px;
  border: 4px outset rgb(133, 224, 242);
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -43px;
  margin-top: -73px;
  border-radius: 43px;
  -moz-animation: rotate-rev 3s infinite linear;
  -webkit-animation: rotate-rev 3s infinite linear;
  animation: rotate-rev 3s infinite linear;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.circle-big {
  width: 120px;
  height: 120px;
  border: 2px dotted rgb(133, 224, 242);
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -60px;
  margin-top: -90px;
  border-radius: 60px;
  -moz-animation: rotate-rev 10s infinite linear;
  -webkit-animation: rotate-rev 10s infinite linear;
  animation: rotate-rev 10s infinite linear;
}

.circle-inner {
  width: 40px;
  height: 40px;
  background-color: rgb(133, 224, 242);
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -20px;
  margin-top: -50px;
  border-radius: 20px;
  -moz-animation: pulse 1.5s infinite ease-in;
  -webkit-animation: pulse 1.5s infinite ease-in;
  animation: pulse 1.5s infinite ease-in;
  opacity: 1;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.circle-inner-inner {
  width: 50px;
  height: 50px;
  background-color: rgb(74, 124, 134);
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -55px;
  border-radius: 25px;
  -moz-animation: pulse 1.5s infinite ease-in;
  -webkit-animation: pulse 1.5s infinite ease-in;
  animation: pulse 1.5s infinite ease-in;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

@-moz-keyframes rotate {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/*==============ROTATE-REV=================*/

@-moz-keyframes rotate-rev {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(-360deg);
  }
}

@-webkit-keyframes rotate-rev {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(-360deg);
  }
}

@keyframes rotate-rev {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

/*==============PULSE======================*/

@-moz-keyframes pulse {
  0% {
    -moz-transform: scale(0.1);
    opacity: 0.2;
  }
  50% {
    -moz-transform: scale(1);
    opacity: 0.8;
  }
  100% {
    -moz-transform: scale(0.1);
    opacity: 0.2;
  }
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale(0.1);
    opacity: 0.2;
  }
  50% {
    -webkit-transform: scale(1);
    opacity: 0.8;
  }
  100% {
    -webkit-transform: scale(0.1);
    opacity: 0.2;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.1);
    opacity: 0.2;
  }
  50% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(0.1);
    opacity: 0.2;
  }
}
</style>
